import { Item, ItemContent, ItemMedia, ItemTitle } from '@ps/ds/components/blocks/Item/Item'
import { Avatar } from '@ps/ds/components/primitives/Avatar/Avatar'
import { TreatmentStatusIndicator } from 'src/features/treatment/components/TreatmentStatusIndicator'
import type { TreatmentStatus } from 'src/features/treatment/constants/treatment'

type TreatmentEntryRowProps = {
  pestImage?: string | null
  pestName: string
  status: TreatmentStatus
}

export const TreatmentEntryRow = ({ pestImage, pestName, status }: TreatmentEntryRowProps) => {
  return (
    <Item className="gap-4 p-0">
      <ItemMedia variant="image">
        <Avatar
          size="sm"
          src={pestImage ?? undefined}
          alt={pestName}
          className="h-10 w-10 rounded-md bg-alabaster-200"
        />
      </ItemMedia>

      <ItemContent className="gap-0.5">
        <ItemTitle className="text-base">{pestName}</ItemTitle>
        <TreatmentStatusIndicator status={status} />
      </ItemContent>
    </Item>
  )
}
